"use strict";

const TargetLesionsCtrl = function(PatientsService){
    var ctrl = this;

    ctrl.$onInit = function(){
      for (var i in ctrl.patient.targetLesions){
        if (ctrl.patient.targetLesions.hasOwnProperty(i)){
          // get affected treatment actions for this target lesion
          (function(j) {
            PatientsService.findTreatmentActionsByTargetLesion(ctrl.patient.pid, j).then(function (data) {
              ctrl.patient.targetLesions[j].affectedActions = data.data;
            });
          })(i);
        }
      }
    };

    ctrl.isEmpty = function(obj){
      for (var item in obj) {
        if (obj.hasOwnProperty(item)) {
          return false;
        }
      }
      return true;
    };
  };

TargetLesionsCtrl.$inject = ['PatientsService'];

module.exports = {
  bindings: {
    patient: '<'
  },
  template: require('./target-lesions.html'),
  controller: TargetLesionsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/target-lesions/target-lesions.component.js